var exports = {
  "CR": "FollowListModal.module__modalRoot___enJLZn",
  "f5": "FollowListModal.module__restartBar___enJLZn",
  "Qs": "FollowListModal.module__content___enJLZn",
  "Ge": "FollowListModal.module__rows___enJLZn",
  "nM": "FollowListModal.module__row___enJLZn",
  "Cd": "FollowListModal.module__userButton___enJLZn",
  "Dy": "FollowListModal.module__names___enJLZn",
  "QC": "FollowListModal.module__displayName___enJLZn",
  "Tc": "FollowListModal.module__tag___enJLZn",
  "DT": "FollowListModal.module__removeButton___enJLZn",
  "Yz": "FollowListModal.module__removeIcon___enJLZn",
  "h5": "FollowListModal.module__status___enJLZn",
  "qS": "FollowListModal.module__statusText___enJLZn",
};

module.exports = exports;
